<template>
  <NuxtLayout>
    <NuxtLoadingIndicator color="primary"/>
    <NuxtPage/>
  </NuxtLayout>
</template>
